import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { environment } from '../../../environments/environment';

interface ErrorNotificationConfig {
  autoHide?: boolean;
  autoHideDuration?: number;
}

class ErrorNotification {
  time: string;
  message: string;
  autoHide: boolean;
  autoHideDuration: number;

  constructor(message: string, { autoHide = true, autoHideDuration = 15000 }: ErrorNotificationConfig = {}) {
    this.time = DateTime.now().toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS, {
      locale: environment.locale,
    });
    this.message = message;
    this.autoHide = autoHide;
    this.autoHideDuration = autoHideDuration;
  }
}

@Injectable({ providedIn: 'root' })
export class ErrorNotificationsService {
  errors: ErrorNotification[] = [];

  showGenericError(error: Error) {
    this.showError(error.message);
  }

  showFailedPaymentError(message: string) {
    const formattedMessage = [
      $localize`Kauf fehlgeschlagen mit Fehler:`,
      '\n',
      `- ${message}`
    ].join('');
    this.showError(formattedMessage);
  }

  showError(message: string, config?: ErrorNotificationConfig) {
    const error = new ErrorNotification(message, config);
    const previousErrorIndex = this.errors.findIndex(notification => notification.message === message);
    if (previousErrorIndex >= 0) {
      this.errors.splice(previousErrorIndex, 1, error);
    } else {
      this.errors.push(error);
    }
  }

  hide(errorNotification: ErrorNotification) {
    this.errors = this.errors.filter(error => error !== errorNotification);
  }
}
